import { Listener } from './Listener';
import { TrackingHandler } from '../TrackingHandler';
export class ServerSideGtmListener extends Listener {
    eventCount = 0;
    formStart(formName, inputName) {
        this.sendEvent('form start', {
            name: formName,
            input: inputName,
        });
    }
    formNavigate(formName, formStep, navigationAction, data) {
        this.sendEvent('form navigate', {
            name: formName,
            step: formStep,
            input: navigationAction,
        });
    }
    formSubmit(formName, data) {
        this.sendEvent('form submit', {
            name: formName,
            eventId: typeof window.form === 'object' && typeof window.form.eventId === 'string' ? window.form.eventId : '',
            data: {
                origin_campaign_c: data.origin_campaign_c,
                origin_medium_c: data.origin_medium_c,
                origin_source_c: data.origin_source_c,
            },
        });
    }
    chatStart() {
    }
    chatEnd() {
    }
    pageReady() {
        this.sendEvent('page view', {
            title: document.title,
        });
    }
    setConsent(essential, functional, marketing) {
        this.sendEvent('consent update');
    }
    static async compileEvent(eventData, additionalTrackingData = {}) {
        const trackingHandler = TrackingHandler.getInstance();
        await trackingHandler.initialized;
        const trackingData = trackingHandler.getAllTrackingData();
        const requestData = {
            event: eventData.name,
            data: eventData.data,
            user: {
                session: trackingHandler.functionalConsent ? trackingHandler.visitId : null,
                sessionTimestamp: trackingHandler.visitTimestamp,
                device: trackingHandler.functionalConsent ? trackingHandler.visitorId : null,
                deviceTimestamp: trackingHandler.visitorTimestamp,
                trackingData: Object.assign({}, trackingData, additionalTrackingData),
            },
            time: eventData.time,
            consent: trackingHandler.consent,
            consentModeV2: {
                adStorage: trackingHandler.consent.marketing,
                adUserData: trackingHandler.consent.marketing,
                adPersonalization: trackingHandler.consent.marketing,
                analyticsStorage: trackingHandler.consent.functional,
                functionalityStorage: false,
                personalizationStorage: false,
                securityStorage: false,
            },
            source: {
                type: eventData.sourceType,
                id: eventData.sourceId,
                previousId: eventData.previousSourceId,
            },
            count: eventData.count,
            countSession: eventData.sessionCount,
        };
        const requestHeaders = new Headers();
        requestHeaders.append('Accept', 'application/json');
        requestHeaders.append('Content-Type', 'application/json');
        return {
            method: 'POST',
            body: JSON.stringify(requestData),
            headers: requestHeaders,
            credentials: 'include',
        };
    }
    async sendEvent(eventName, data = {}) {
        if (!window.siteSettings.enableSSGTM) {
            return;
        }
        this.eventCount++;
        let sessionEventCount = null;
        const trackingHandler = TrackingHandler.getInstance();
        if (trackingHandler.functionalConsent) {
            const sessionEventCountString = sessionStorage.getItem('sgEventCount');
            sessionEventCount = sessionEventCountString ? parseInt(sessionEventCountString) + 1 : 1;
            sessionStorage.setItem('sgEventCount', sessionEventCount.toString());
        }
        const request = await ServerSideGtmListener.compileEvent({
            name: eventName,
            count: this.eventCount,
            sessionCount: sessionEventCount,
            time: new Date().getTime(),
            sourceType: 'web',
            sourceId: window.location.toString(),
            previousSourceId: document.referrer || null,
            data,
        });
        const xhr = new XMLHttpRequest();
        xhr.open(request.method || 'POST', window.endpoints.tracking);
        xhr.responseType = 'json';
        if (request.headers instanceof Headers) {
            request.headers.forEach((value, key) => {
                xhr.setRequestHeader(key, value);
            });
        }
        if (request.credentials === 'include') {
            xhr.withCredentials = true;
        }
        xhr.send(request.body);
        xhr.onreadystatechange = () => {
            if (xhr.readyState === XMLHttpRequest.DONE &&
                xhr.response &&
                typeof xhr.response === 'object' &&
                typeof xhr.response.type === 'string') {
                switch (xhr.response.type) {
                    case 'script':
                        if (typeof xhr.response.script !== 'string') {
                            return;
                        }
                        eval(xhr.response.script);
                }
            }
        };
    }
}
